// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3H2LC","ranges":"BmiRanges_ranges__gfDoy"};